import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, SelectProps, TextField } from "@mui/material";
import { FieldAttributes, Form, Formik, useField } from "formik";
import { FMTextField } from "../Elements/input";
import React from "react";
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { apiClient } from "../../helper/api";
import useAuth from "../../context/AuthProvider";
import { config } from "../../Constants";
import saveAs from "file-saver";
import Swal from "sweetalert2";
import { br9Data_resp, br18Data_resp } from "../../models/StateReportModel";
interface Iprops {
  handleClose: () => void,
  Open: boolean,
  br18Data: br18Data_resp,
  br9Data: Array<br9Data_resp>
}
interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
        prefix="$"
        decimalScale={2}
        fixedDecimalScale={true}
        allowLeadingZeros={true}
      />
    );
  },
);

export const Br18Form: React.FC<Iprops> = ({ handleClose, Open, br18Data, br9Data }) => {
  const { user } = useAuth();
  const token = user?.token;
  const initialValues: br18Data_resp = br18Data;
  const handleSubmit = async (val: br18Data_resp) => {
    const cellUpdates = {
      MS_GROSS_PREMIUMS_CHARGED: val.e24GrossPremiumsCharged || '0',
      MS_LESS_RETURNED: val.e25AmountOfReturnedPremiums,
      Attestation: val.a33Attestation || '',
      BR18_DATE: val.b33DateInFormat || '',
      BR18_SPEC_BROKER_NAME: val.d33SpecialBrokerName || '',
      BUSINESS_ADDRESS: val.b36BusinessAddress || '',
      TELEPHONE_NUMBER: val.b37TelephoneNumber || '',
      BROKERS_LICENSE_NUMBER: val.b38BrokerLicenseNumber || '',
      AUTHORIZED_OFFICER: val.b39AuthorizedOfficer || '',
      EMAIL_ADDRESS: val.b40EmailAddress || '',
      PREPARERS_NAME: val.b41PreparersName || '',
      PREPARERS_TELEPHONE: val.b42PreparersTelephone || '',
      PREPARERS_EMAIL: val.b43PreparersEMailAddress || '',
    }

    const bodyReq = {
      cellUpdates,
      br9Data
    }
    console.log(bodyReq)
    const res = await apiClient(`/StateReports/UpdateBr18`, {
      method: "POST",
      headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      }),
      body: JSON.stringify(bodyReq)
    })
    try {
      const blob = await res.blob();
      saveAs(blob, "UpdatedFile.xlsm");

      Swal.fire({
        title: "Successful!",
        text: "",
        icon: "success",
        confirmButtonText: "OK",
      }).finally(() => {
        handleClose()
      });

    } catch (error) {
      console.error("Error downloading file:", error);
    }
  }
  return (

    <Dialog open={Open} onClose={handleClose} maxWidth={'lg'}>
      <DialogTitle className='card-title' >BR18 Form</DialogTitle>
      <Formik initialValues={initialValues}
        enableReinitialize={true}
        validateOnChange={true}
        onSubmit={(data, { setSubmitting }) => {
          handleSubmit(data)
        }} >
        {({ values, isSubmitting, setFieldValue, errors }) => (
          <Form className='main-form' >
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }} >
                    <FMTextField name="a33Attestation" autoFocus margin="dense" label="Attestation" placeholder="Attestation" type="text" fullWidth variant="outlined" sx={{ m: 2, width: '100%' }} />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }}>
                    <FMTextField
                      name="d33SpecialBrokerName"
                      autoFocus
                      margin="dense"
                      label="Special Broker Name"
                      placeholder="Special Broker Name"
                      type="text"
                      fullWidth
                      variant="outlined"
                      sx={{ m: 2, width: '100%' }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }} >
                    <FMTextField name="b36BusinessAddress" autoFocus margin="dense" label="Business Address" placeholder="Business Address" type="text" fullWidth variant="outlined" sx={{ m: 2, width: '100%' }} />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }} >
                    <FMTextField name="b37TelephoneNumber" autoFocus margin="dense" label="Telephone Number" placeholder="Telephone Number" type="text" fullWidth variant="outlined" sx={{ m: 2, width: '100%' }} />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }} >
                    <FMTextField name="b38BrokerLicenseNumber" autoFocus margin="dense" label="Broker License Number" placeholder="Broker License Number" type="text" fullWidth variant="outlined" sx={{ m: 2, width: '100%' }} />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }} >
                    <FMTextField name="b39AuthorizedOfficer" autoFocus margin="dense" label="Authorized Officer" placeholder="Authorized Officer" type="text" fullWidth variant="outlined" sx={{ m: 2, width: '100%' }} />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }} >
                    <FMTextField name="b40EmailAddress" autoFocus margin="dense" label="Email Address" placeholder="Email Address" type="text" fullWidth variant="outlined" sx={{ m: 2, width: '100%' }} />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }} >
                    <FMTextField name="b41PreparersName" autoFocus margin="dense" label="Preparers Name" placeholder="Preparers Name" type="text" fullWidth variant="outlined" sx={{ m: 2, width: '100%' }} />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }} >
                    <FMTextField name="b42PreparersTelephone" autoFocus margin="dense" label="Preparers Telephone" placeholder="Preparers Telephone" type="text" fullWidth variant="outlined" sx={{ m: 2, width: '100%' }} />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }} >
                    <FMTextField name="b43PreparersEMailAddress" autoFocus margin="dense" label="Preparers Email Address" placeholder="Preparers Email Address" type="text" fullWidth variant="outlined" sx={{ m: 2, width: '100%' }} />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }}>
                    <FMTextField
                      name="e24GrossPremiumsCharged"
                      label="Gross Premiums Charged"
                      placeholder="Gross Premiums Charged"
                      type="text"
                      fullWidth
                      variant="outlined"
                      sx={{ m: 2, width: '100%' }}
                      InputProps={{
                        inputComponent: NumericFormatCustom as any,
                      }}
                      isAllowZero
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }}>
                    <FMTextField
                      name="e25AmountOfReturnedPremiums"
                      label="Amount Of Returned Premiums"
                      placeholder="Amount Of Returned Premiums"
                      type="text"
                      fullWidth
                      variant="outlined"
                      sx={{ m: 2, width: '100%' }}
                      InputProps={{
                        inputComponent: NumericFormatCustom as any,
                      }}
                      isAllowZero
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <button className=" btn-2 btn d-flex btn-primary search-btn" type='button' onClick={handleClose}  >Cancel</button>
              <button className="btn  btn-primary active-btn-blue  search-btn " type='submit' disabled={isSubmitting} >Submit</button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog >
  )
}
